module.exports = __webpack_public_path__ + "static/media/24UHCHR10.f33d033c.jpg";